module.exports = __webpack_public_path__ + "img/logo-cotizacion.ab051d3a.png";